import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que recibe el API del contact center, segun nombre en los formularios
export const CONTACTCENTER: StringValues = {
    consignmentDate: "fecha_out",
    entitiesList: "entitiesList",
    identification: "cedula",
    fullManager: "encargado",
    clasification: "clas",
    file: "archivoupload",
    portfolioType: "car",
    managers: "jsonId",
    fullDate: "fecha",
    credit: "credito",
    entity: "entidad",
    operation: "ope",
    enMonth: "month",
    period: "period",
    goals: "jsonVlr",
    entities: "ent",
    state: "estado",
    manager: "enc",
    filter: "filt",
    enYear: "year",
    value: "valor",
    check: "chk",
    month: "mes",
    year: "anio",
    date: "fec",
    id: "id",
};
